import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../../store/slices/currentUser";

export default function useAuth() {
  const { authorized } = useSelector(selectCurrentUser);

  return authorized;
}
